import React, { useState, useEffect, useCallback, useRef } from 'react';
import { getPostResponseCSV } from '../../services/apiService';
import { useDispatch, useSelector } from 'react-redux';
import { CSVLink } from 'react-csv';
import download from '../../assets/img/Export-Download.svg';
import styled from 'styled-components';
import { IsdownloadCSV, showLoader } from '../../slices/customQueryHeaderSlice';
import Spinner from '@material-ui/core/CircularProgress';
import { Button } from '@material-ui/core';
import consts from '../../utils/consts';
const StyledButton = styled(Button)`
  &.MuiButton-root {
    display: flex;
    text-transform: none;
    font-size: 13px;
    line-height: 24px;
    font-family: 'OpenSans-Light';
    color: #212121;
    opacity: 0.87;
  }
`;
export const ExportToExcel = ({
  apiUrl,
  apiRequestBody,
  totalCount,
  fileName,
  loader
}) => {
  const dispatch = useDispatch();
  const [results, setResults] = useState([]);
  const csvLinkEl = useRef();
  const apiResponseData = useSelector(state => state.customQueryHeader.exportCSV);
  const {
    operationsNamesArray,
    userAccountOperations,
    oprPreValues
  } = consts;
  const selectedChipArray = useSelector(state => state.customQueryBody.ChipArrayAddCriteria);
  const accordianKeyItems = useSelector(state => state.entityCard.accordionKeyItems);
  const downloadCSV = useSelector(state => state.customQueryHeader.downloadCSVResults);
  const [currentDate, setCurrentDate] = useState();

  const getResults = (apiUrl, apiRequestBody, totalCount) => {
    dispatch(showLoader(true));
    let d = new Date();
    let year = d.getFullYear();
    let month = d.getMonth() + 1;
    let date = d.getDate();
    setCurrentDate(year + '-' + month + '-' + date);
    let urlArray = [];
    let request = apiRequestBody;

    if (request === undefined) {
      request = getRequestBody();
    }

    for (let i = 0; i <= totalCount / 50000; i++) {
      urlArray.push(i);
    }

    dispatch(getPostResponseCSV(urlArray, apiUrl, request, 'exportCSV'));
    dispatch(IsdownloadCSV(true));
  };

  function getRequestBody() {
    let requestBody = {};
    let selectedQueryArray = selectedChipArray;
    let operationsArr = operationsNamesArray.concat(userAccountOperations);
    let isObj = {
      accountIdList: [],
      applicationList: [],
      applicationTypeList: [],
      environmentIdList: [],
      environmentNameList: [],
      groupNameList: [],
      permissionNameList: [],
      resourceIdList: [],
      resourceNameList: [],
      resourceTypeList: [],
      roleNameList: [],
      userNameList: []
    };
    let userAccountObj = '';
    let arr = accordianKeyItems.map(el => el.entityKeys);
    let mergedArray = [].concat.apply([], arr);
    mergedArray = mergedArray.filter(item => item !== 'User Account');
    let keyValueObj = {};
    let keyValName = '';
    mergedArray.forEach(arr => {
      if (arr === 'APPLICATION') {
        keyValName = 'appName';
      } else if (arr === 'APPLICATION_TYPE') {
        keyValName = 'appType';
      } else if (arr === 'ENVIRONMENT_NAME') {
        keyValName = 'environmentName';
      } else if (arr === 'ENVIRONMENT_ID') {
        keyValName = 'environmentId';
      } else if (arr === 'GROUP_NAME') {
        keyValName = 'groupName';
      } else if (arr === 'PERMISSION_NAME') {
        keyValName = 'permissionName';
      } else if (arr === 'SERVICE_RESOURCE_NAME') {
        keyValName = 'resourceName';
      } else if (arr === 'SERVICE_RESOURCE_TYPE') {
        keyValName = 'resourceType';
      } else if (arr === 'ROLE_NAME') {
        keyValName = 'roleName';
      } else if (arr === 'USER_ACCOUNT_NAME') {
        keyValName = 'userName';
      }

      keyValueObj[keyValName] = null;
    });
    let riskObj = {
      riskRange: '',
      riskType: []
    };
    let activity = {
      activityPeriod: '',
      between: ''
    };
    let access = {
      accessDays: '',
      accessType: ''
    };
    requestBody['access'] = access;
    requestBody['activity'] = activity;
    requestBody['risk'] = riskObj;

    for (let i = 0; i < operationsArr.length; i++) {
      let operationKey = operationsArr[i];

      if (operationKey === 'is') {
        requestBody[operationKey] = isObj;
      } else if (operationKey === 'since' || operationKey === 'before' || operationKey === 'on') {
        requestBody[operationKey] = userAccountObj;
      } else {
        requestBody[operationKey] = oprPreValues;
      }
    }

    let keyJson = [];

    for (let tagItem of selectedQueryArray) {
      let selectedOpr = '';

      for (let oprationItem of operationsArr) {
        if (tagItem.indexOf(' contains ') > -1) {
          selectedOpr = 'contains';
          break;
        } else if (tagItem.indexOf(' startsWith ') > -1) {
          selectedOpr = 'startsWith';
          break;
        } else if (tagItem.indexOf(' endsWith ') > -1) {
          selectedOpr = 'endsWith';
          break;
        } else if (tagItem.indexOf(' since ') > -1) {
          selectedOpr = 'since';
          break;
        } else if (tagItem.indexOf(' before ') > -1) {
          selectedOpr = 'before';
          break;
        } else if (tagItem.indexOf(' on ') > -1) {
          selectedOpr = 'on';
          break;
        } else if (tagItem.indexOf(oprationItem) > -1) {
          selectedOpr = oprationItem;
          break;
        } else {
          selectedOpr = oprationItem;
          break;
        }
      }

      let tagStringArray = [];

      if (tagItem.indexOf(selectedOpr) > -1) {
        tagStringArray = tagItem.split(' ' + selectedOpr + ' ');
      }

      let existIndex = keyJson.findIndex(el => el.entityName === tagStringArray[0] && el.entityOpr === selectedOpr);

      if (existIndex > -1 && selectedOpr !== 'is') {
        keyJson[existIndex].entityValue += ', ' + tagStringArray[1];
      } else {
        let obj = {};
        obj['entityName'] = tagStringArray[0];
        obj['entityValue'] = tagStringArray[1];
        obj['entityOpr'] = selectedOpr;
        keyJson.push(obj);
      }
    }

    for (let item of keyJson) {
      let currentEntityOpr = '';

      if (item.entityName === 'Risk Type' || item.entityName === 'Risk Score') {
        currentEntityOpr = 'risk';
        item.entityOpr = 'risk';
      } else {
        currentEntityOpr = item.entityOpr;
      }

      let selectedOpr = { ...requestBody[currentEntityOpr]
      };

      if (item.entityOpr === 'is') {
        if (item.entityName === 'Application') {
          selectedOpr['applicationList'].push(item.entityValue);
        } else if (item.entityName === 'Application Type') {
          selectedOpr['applicationTypeList'].push(item.entityValue);
        } else if (item.entityName === 'Environment Name') {
          selectedOpr['environmentNameList'].push(item.entityValue);
        } else if (item.entityName === 'Environment Id') {
          selectedOpr['environmentIdList'].push(item.entityValue);
        } else if (item.entityName === 'Group Name') {
          selectedOpr['groupNameList'].push(item.entityValue);
        } else if (item.entityName === 'Permission Name') {
          selectedOpr['permissionNameList'].push(item.entityValue);
        } else if (item.entityName === 'Service Resource Name') {
          selectedOpr['resourceNameList'].push(item.entityValue);
        } else if (item.entityName === 'Service Resource Type') {
          selectedOpr['resourceTypeList'].push(item.entityValue);
        } else if (item.entityName === 'Role Name') {
          selectedOpr['roleNameList'].push(item.entityValue);
        } else if (item.entityName === 'User Account Name') {
          selectedOpr['userNameList'].push(item.entityValue);
        }
      } else if (item.entityOpr === 'since' || item.entityOpr === 'before' || item.entityOpr === 'on') {
        // For User Account
        selectedOpr = item.entityValue;
      } else if (item.entityName === 'Risk Type' || item.entityName === 'Risk Score') {
        if (item.entityName === 'Risk Type') {
          selectedOpr['riskType'].push(item.entityValue);
        } else if (item.entityName === 'Risk Score') {
          let scoreString = item.entityValue.split(' to ');
          selectedOpr['riskRange'] = scoreString[0] + ',' + scoreString[1];
        }
      } else {
        let eName = item.entityName;
        let keyValName = '';

        if (eName === 'Application') {
          keyValName = 'appName';
        } else if (eName === 'Application Type') {
          keyValName = 'appType';
        } else if (eName === 'Environment Name') {
          keyValName = 'environmentName';
        } else if (eName === 'Environment Id') {
          keyValName = 'environmentId';
        } else if (eName === 'Group Name') {
          keyValName = 'groupName';
        } else if (eName === 'Permission Name') {
          keyValName = 'permissionName';
        } else if (eName === 'Service Resource Name') {
          keyValName = 'resourceName';
        } else if (eName === 'Service Resource Type') {
          keyValName = 'resourceType';
        } else if (eName === 'Role Name') {
          keyValName = 'roleName';
        } else if (eName === 'User Account Name') {
          keyValName = 'userName';
        }

        if (Object.prototype.hasOwnProperty.call(requestBody[item.entityOpr], keyValName)) {
          selectedOpr[keyValName] = item.entityValue;
        }
      }

      requestBody[item.entityOpr] = selectedOpr;
    }

    return requestBody;
  }

  useEffect(() => {
    if (apiResponseData) {
      setResults(apiResponseData);
      getCSVFile();
    }

    return () => {
      setResults([]);
    };
  }, [apiResponseData]);
  const getCSVFile = useCallback(() => {
    dispatch(showLoader(false));
    setTimeout(() => {
      let csvLink = csvLinkEl.current;

      if (csvLink != null) {
        csvLinkEl.current.link.click();
        dispatch(IsdownloadCSV(false));
      }
    });
  }, [apiResponseData]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, results.length == totalCount && downloadCSV ? /*#__PURE__*/React.createElement(CSVLink, {
    data: results,
    filename: `${fileName}_${currentDate}.csv`,
    target: "_blank",
    ref: csvLinkEl
  }) : '', /*#__PURE__*/React.createElement(StyledButton, {
    onClick: () => getResults(apiUrl, apiRequestBody, totalCount, fileName),
    startIcon: loader ? /*#__PURE__*/React.createElement(Spinner, {
      animation: "border",
      role: "status",
      size: 10,
      style: {
        marginRight: '1px',
        marginLeft: '5px'
      }
    }) : /*#__PURE__*/React.createElement("img", {
      alt: "download",
      src: download,
      style: {
        marginRight: '-8px'
      }
    }),
    disabled: loader
  }, "Export"));
};